import { v4 as uuidv4 } from 'uuid';
export const createWsMessageIn = (type, data) => {
    const msg = { type, data, event_id: uuidv4(), timestamp: new Date().toISOString() };
    return JSON.stringify(msg);
};
export const createWsMessageOut = (type, data) => {
    const msg = { type, data, event_id: uuidv4(), timestamp: new Date().toISOString() };
    return JSON.stringify(msg);
};
//# sourceMappingURL=ws.utils.js.map